import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { EMAIL_PATTERN } from '../../../core/constants/validatation-regex.constants';
import { AuthenticationService } from '../../../core/services/authentication/authentication.service';
import { AuthorizationResponseModel } from '../../models/auth/authorize.models';
import { FORBIDDEN_403, NOT_VALID_422, SUCCESS } from '../../../core/constants/statuses.constants';
import { PLEASE_VERIFY_DEVICE } from '../../../core/constants/validation-error-strings.constants';
import {catchError} from "rxjs/operators";
import {EMPTY} from "rxjs";

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent implements OnInit {

  @Input() hideLoginButton: boolean | undefined;
  @Input() redirectCallback;
  @Output() loginCallback = new EventEmitter();

  loginForm: UntypedFormGroup;
  submitted = false;
  loginError = false;
  isLoading = false;
  showDeviceVerifyForm = false;
  userId: number;

  constructor(private auth: AuthenticationService,
    private formBuilder: UntypedFormBuilder) {
  }

  ngOnInit(): void {
    this.createForm();
  }

  /**
   * Create form object for login
   * @private
   */
  private createForm(): void {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern(EMAIL_PATTERN)]],
      password: ['', Validators.required]
    });
    this.loginCallback.emit({
      login: () => {
        this.login();
      }
    });
  }

  get email(): AbstractControl {
    return this.loginForm.get('email');
  }

  get password(): AbstractControl {
    return this.loginForm.get('password');
  }

  /**
   * Login
   */
  login(): void {
    this.submitted = true;
    this.loginError = false;
    this.loginForm.markAllAsTouched();
    if (this.loginForm.valid) {
      this.isLoading = true;
      this.auth.login(this.loginForm.value, this.redirectCallback)
        .pipe(
          catchError(() => {
            return EMPTY;
          })
        )
        .subscribe((data: AuthorizationResponseModel | null) => {

          if (data != null && data.status === NOT_VALID_422) {
            this.loginCallback.emit({
              stopLoader: true
            });
            this.loginError = true;
          } else if (data != null
            && data.status === FORBIDDEN_403
            && data.message === PLEASE_VERIFY_DEVICE) {
            this.loginCallback.emit({
              stopLoader: true
            });
            this.showDeviceVerifyForm = true;
            this.userId = data.userId;
            this.auth.showFooterInMainLogin = false;
          } else if (this.redirectCallback
            && data != null
            && data.status === SUCCESS) {
            this.redirectCallback();
          } else {
            this.showDeviceVerifyForm = false;
            this.userId = undefined;
            this.auth.showFooterInMainLogin = true;
            this.loginCallback.emit({
              stopLoader: true
            });
          }

          this.isLoading = false;

        });
    } else {
      this.loginCallback.emit({
        stopLoader: true
      });
    }
  }

  /**
   * Emmit function from device verify component
   * @param status
   */
  verifyDevice(status): void {
    if (status) {
      this.login();
    }
  }

}
